"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = parse;
const uom_1 = require("@genesys/uom");
function parse(velocities) {
    const units = velocities[0].map(v => uom_1.Serialize.stringToUnit(v.substring(1, v.length - 1)));
    const velocitiesList = [];
    let velocityList = [];
    for (const velocity of velocities.slice(2)) {
        if (velocity[0]) {
            velocityList.push(velocity);
        }
        else if (velocityList.length) {
            velocitiesList.push(velocityList);
            velocityList = [];
        }
    }
    if (velocityList.length) {
        velocitiesList.push(velocityList);
    }
    return {
        units: {
            velocity: units[0],
            power: units[1],
            pressure: units[2]
        },
        input: velocitiesList.map(l => l.map(v => {
            const parseAmount = createParseAmount(v, units);
            return {
                velocity: parseAmount(0),
                supplierPower: parseAmount(1),
                supplierPressure: parseAmount(2)
            };
        }))
    };
}
function createParseAmount(row, units) {
    return (index) => {
        const unit = units[index];
        if (!unit) {
            throw new Error("Velocity: Unknown unit at column index: " + index);
        }
        const amount = row[index];
        const value = parseFloat(amount);
        return uom_1.Serialize.amountToString(uom_1.Amount.create(value, unit));
    };
}
//# sourceMappingURL=parse-velocity.js.map